export default __webpack_public_path__ + "static/media/LogoPredictLanding.dcced75a.svg";